import router from "src/http/router";

export default {
  name: "append-vue-route-to-request",
  req(payload) {
    payload.req.vueRoute = router.currentRoute;
    return payload;
  }
};
